import API from "../services/api";
import storage from '../services/general/storage';
const attribute = "clients";

const Service = {
  get: id => {
    return new Promise((resolve, reject) => {
      API.get(id ? attribute + "/" + id : attribute).then(
        result => {
          resolve(result);
          storage.setCollectionObject(attribute, id, result);
        },
        error => {
          storage.getCollectionObject(attribute, id)
            .then((foundStorage) => {
              resolve(foundStorage);
            }, (err) => {
              reject(err);
            })

        }
      );
    });
  },

  save: item => {
    return new Promise((resolve, reject) => {
      if (item._id) {
        API.post(attribute + "/" + item._id, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      } else {
        API.put(attribute, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  },
  delete: id => {
    return new Promise((resolve, reject) => {
      API.deleteItem(attribute + "/" + id).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  canSetKm: projectId => {
    return new Promise((resolve, reject) => {

    });
  },
  canSetNights: projectId => {
    return new Promise((resolve, reject) => {

    });
  },
  import: () => {
    
   
  }
};

export default Service;
